import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Footer } from "@/components/Footer";

export const LegalLayout = ({ title, updated, children, testid }) => {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="min-h-screen flex flex-col" data-testid={testid}>
      <div className="flex-1 px-6 sm:px-10 py-8">
        <header className="max-w-2xl mx-auto flex items-center justify-between">
          <button
            data-testid="legal-back-button"
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-[var(--mirror-text-3)] hover:text-[var(--mirror-text)] transition-opacity duration-500 text-sm"
          >
            <ArrowLeft size={16} /> Back
          </button>
          <span className="text-xs tracking-[0.35em] uppercase text-[var(--mirror-text-2)]">
            Mirror
          </span>
        </header>

        <main className="max-w-2xl mx-auto mt-16 pb-16">
          <h1 className="font-serif-display font-light text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[var(--mirror-text)]">
            {title}
          </h1>
          <p className="mt-3 text-xs tracking-[0.2em] uppercase text-[var(--mirror-text-3)]">
            {updated}
          </p>
          <div className="mt-12 space-y-10">{children}</div>
        </main>
      </div>
      <Footer />
    </div>
  );
};

export const Section = ({ heading, children }) => (
  <section>
    <h2 className="font-serif-display text-xl sm:text-2xl font-light text-[var(--mirror-text)]">
      {heading}
    </h2>
    <div className="mt-4 space-y-4 text-[var(--mirror-text-2)] text-base leading-relaxed">
      {children}
    </div>
  </section>
);
